import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import EmployeesList from "@/pages/EmployeesList";
import EmployeeForm from "@/pages/EmployeeForm";
import BulkUpload from "@/pages/BulkUpload";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";
import DisasterRecovery from "@/pages/DisasterRecovery";
import FleetCompliance from "@/pages/FleetCompliance";
import Compliance from "@/pages/Compliance";
import AttendanceList from "@/pages/AttendanceList";
import AttendanceUpload from "@/pages/AttendanceUpload";
import AttendanceReview from "@/pages/AttendanceReview";
import AttendanceMonthly from "@/pages/AttendanceMonthly";
import AttendanceAnomalies from "@/pages/AttendanceAnomalies";
import LeaveLedger from "@/pages/LeaveLedger";
import Approvals from "@/pages/Approvals";
import Exits from "@/pages/Exits";
import VendorPayments from "@/pages/VendorPayments";
import DashboardJoiners from "@/pages/DashboardJoiners";
import DashboardLeft from "@/pages/DashboardLeft";
import DashboardZeroAttendance from "@/pages/DashboardZeroAttendance";
import DashboardDormancy from "@/pages/DashboardDormancy";
import LeaveConfigMaster from "@/pages/LeaveConfigMaster";
import CompanySettings from "@/pages/CompanySettings";
import LiveAttendance from "@/pages/LiveAttendance";
import BiometricDevices from "@/pages/BiometricDevices";
import ChecklistAdmin from "@/pages/ChecklistAdmin";
import ChecklistActivity from "@/pages/ChecklistActivity";
import DriverAttendance from "@/pages/DriverAttendance";
import LogisticsHub from "@/pages/LogisticsHub";
import PayrollList from "@/pages/PayrollList";
import PayrollRunDetail from "@/pages/PayrollRunDetail";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import PortalLayout from "@/components/PortalLayout";
import PortalDashboard from "@/pages/portal/PortalDashboard";
import PortalProfile from "@/pages/portal/PortalProfile";
import PortalAttendance from "@/pages/portal/PortalAttendance";
import PortalSalary from "@/pages/portal/PortalSalary";
import PortalDocuments from "@/pages/portal/PortalDocuments";
import PortalLeaves from "@/pages/portal/PortalLeaves";
import PortalTodos from "@/pages/portal/PortalTodos";
import LeaveApprovals from "@/pages/LeaveApprovals";
import OrgChart from "@/pages/OrgChart";
import PortalHolidays from "@/pages/portal/PortalHolidays";
import AdminHolidays from "@/pages/AdminHolidays";
import AdminOptionalLeaves from "@/pages/AdminOptionalLeaves";
import DelegationCreate from "@/pages/DelegationCreate";
import DelegationList from "@/pages/DelegationList";
import DelegationDetail from "@/pages/DelegationDetail";
import AccountsDashboard from "@/pages/AccountsDashboard";
import EADashboard from "@/pages/EADashboard";
import BiometricMatching from "@/pages/BiometricMatching";
import BiometricMappings from "@/pages/BiometricMappings";
import Unit1BiometricFix from "@/pages/Unit1BiometricFix";
import PayrollRules from "@/pages/PayrollRules";
import CommunicationSettings from "@/pages/CommunicationSettings";
import FastagMap from "@/pages/FastagMap";
import PayrollComparison from "@/pages/PayrollComparison";
import RequestNew from "@/pages/portal/RequestNew";
import RequestList from "@/pages/portal/RequestList";
import RequestDetail from "@/pages/portal/RequestDetail";
import ApprovalQueue from "@/pages/ApprovalQueue";
import RequestAnalytics from "@/pages/RequestAnalytics";
import EmployeeMasterRecord from "@/pages/EmployeeMasterRecord";
import AppraisalDashboard from "@/pages/AppraisalDashboard";
import AppraisalAdmin from "@/pages/AppraisalAdmin";
import AppraisalReview from "@/pages/AppraisalReview";
import PortalAppraisal from "@/pages/portal/PortalAppraisal";
import SalaryCalculator from "@/pages/SalaryCalculator";
import FestivalsList from "@/pages/FestivalsList";
import FestivalDetail from "@/pages/FestivalDetail";
import FestivalTiers from "@/pages/FestivalTiers";
import MyFestivalHistory from "@/pages/portal/MyFestivalHistory";
import MyAdvancesNew, { MyAdvancesList } from "@/pages/portal/MyAdvances";
import AdvanceApprovalQueue from "@/pages/AdvanceApprovalQueue";
import AdvanceReports from "@/pages/AdvanceReports";
import PunchTerminal from "@/pages/PunchTerminal";
import PunchAttendance from "@/pages/PunchAttendance";
import Broadcasts from "@/pages/Broadcasts";
import PortalAnnouncements from "@/pages/portal/PortalAnnouncements";
import PublicPayslip from "@/pages/PublicPayslip";
import FinancialYears from "@/pages/FinancialYears";
import PerformanceScoring from "@/pages/PerformanceScoring";
import MyPerformance from "@/pages/portal/MyPerformance";
import SMChecklist from "@/pages/SMChecklist";
import SMChecklistMonthly from "@/pages/SMChecklistMonthly";
import MySMChecklist from "@/pages/portal/MySMChecklist";
import EAMappings from "@/pages/EAMappings";
import Recruitment from "@/pages/Recruitment";
import VehicleOps from "@/pages/VehicleOps";
import FleetStatusBoard from "@/pages/FleetStatusBoard";
import LMTripMobile from "@/pages/LMTripMobile";
import LMMore from "@/pages/LMMore";
import LMFuelMobile from "@/pages/LMFuelMobile";
import LMShell from "@/components/LMShell";
import EmployeeShell from "@/components/EmployeeShell";
import MeHome from "@/pages/me/MeHome";
import MeAttendance from "@/pages/me/MeAttendance";
import MeTasks from "@/pages/me/MeTasks";
import MeLeaves from "@/pages/me/MeLeaves";
import MeMore from "@/pages/me/MeMore";
import EmployeeAssetHandover from "@/pages/EmployeeAssetHandover";
import MyAssetHandovers from "@/pages/portal/MyAssetHandovers";
import DriverShell from "@/components/DriverShell";
import DriverHome from "@/pages/driver/DriverHome";
import FuelRefill from "@/pages/driver/FuelRefill";
import MyRefills from "@/pages/driver/MyRefills";
import RefillDetail from "@/pages/driver/RefillDetail";
import TripLog from "@/pages/driver/TripLog";
import MyTrips from "@/pages/driver/MyTrips";
import TripDetail from "@/pages/driver/TripDetail";
import MarketReturnLog from "@/pages/driver/MarketReturnLog";
import MyMileage from "@/pages/driver/MyMileage";
import DriverInspection from "@/pages/driver/DriverInspection";
import DriverHandovers from "@/pages/driver/DriverHandovers";
import DriverMaintenance from "@/pages/driver/DriverMaintenance";
import FuelAdmin from "@/pages/FuelAdmin";
import AttendanceV2 from "@/pages/AttendanceV2";
import { useAuth } from "@/context/AuthContext";
import { isPortalUser } from "@/lib/routes";

const Shell = ({ children }) => (
  <ProtectedRoute adminOnly>
    <AppLayout>{children}</AppLayout>
  </ProtectedRoute>
);

const AdminShell = ({ children }) => (
  <ProtectedRoute roles={["super_admin"]} adminOnly>
    <AppLayout>{children}</AppLayout>
  </ProtectedRoute>
);

const HrShell = ({ children }) => (
  <ProtectedRoute roles={["super_admin", "hr"]} adminOnly>
    <AppLayout>{children}</AppLayout>
  </ProtectedRoute>
);

const PortalShell = ({ children }) => (
  <ProtectedRoute portalOnly>
    <PortalLayout>{children}</PortalLayout>
  </ProtectedRoute>
);

// Delegation pages are accessible to BOTH admin (super_admin/hr) and portal principals
// (senior_management/hod/manager/ea/employee). Pick layout based on principal_type.
const DelegationShell = ({ children }) => {
  const InnerShell = () => {
    const { user } = useAuth();
    if (!user) return children;
    return isPortalUser(user)
      ? <PortalLayout>{children}</PortalLayout>
      : <AppLayout>{children}</AppLayout>;
  };
  return (
    <ProtectedRoute>
      <InnerShell />
    </ProtectedRoute>
  );
};

const ComingSoon = ({ title }) => (
  <div className="space-y-2 max-w-xl">
    <div className="text-[10px] uppercase tracking-widest text-slate-400">Phase 2</div>
    <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: "Chivo" }}>{title}</h1>
    <p className="text-sm text-slate-500">
      This module will be enabled in the next phase. Foundation, Auth, Database and Employee Master are live in Phase 1.
    </p>
  </div>
);

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Phase 5N — Public Payslip viewer (NO auth) */}
            <Route path="/p/payslip/:token" element={<PublicPayslip />} />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute allowMustChange>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />

            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/employees" element={<Shell><EmployeesList /></Shell>} />
            <Route path="/employees/new" element={<HrShell><EmployeeForm /></HrShell>} />
            <Route path="/employees/bulk-upload" element={<HrShell><BulkUpload /></HrShell>} />
            <Route path="/employees/:id" element={<Shell><EmployeeForm /></Shell>} />

            <Route path="/attendance" element={<Shell><AttendanceList /></Shell>} />
            <Route path="/attendance/upload" element={<HrShell><AttendanceUpload /></HrShell>} />
            <Route path="/attendance/review/:id" element={<Shell><AttendanceReview /></Shell>} />
            <Route path="/attendance/anomalies/:id" element={<Shell><AttendanceAnomalies /></Shell>} />
            <Route path="/leave-ledger" element={<Shell><LeaveLedger /></Shell>} />
            <Route path="/approvals" element={<Shell><Approvals /></Shell>} />
            <Route path="/exits" element={<Shell><Exits /></Shell>} />
            <Route path="/vendor-payments" element={<ProtectedRoute roles={["super_admin", "senior_management", "accounts"]}><AppLayout><VendorPayments /></AppLayout></ProtectedRoute>} />
            <Route path="/dashboard/joiners" element={<Shell><DashboardJoiners /></Shell>} />
            <Route path="/dashboard/left" element={<Shell><DashboardLeft /></Shell>} />
            <Route path="/dashboard/zero-attendance" element={<Shell><DashboardZeroAttendance /></Shell>} />
            <Route path="/dashboard/dormancy" element={<Shell><DashboardDormancy /></Shell>} />
            <Route path="/admin/leave-config" element={<HrShell><LeaveConfigMaster /></HrShell>} />
            <Route path="/admin/company-settings" element={<HrShell><CompanySettings /></HrShell>} />
            <Route path="/admin/appraisal" element={<HrShell><AppraisalAdmin /></HrShell>} />
            <Route path="/appraisal/reviews" element={<ProtectedRoute><AppLayout><AppraisalReview /></AppLayout></ProtectedRoute>} />
            <Route path="/my-portal/appraisal" element={<PortalShell><PortalAppraisal /></PortalShell>} />
            <Route path="/live-attendance" element={<Shell><LiveAttendance /></Shell>} />
            <Route path="/admin/biometric-devices" element={<Shell><BiometricDevices /></Shell>} />
            {/* Phase 6 — Recurring Checklist */}
            <Route path="/admin/checklist" element={<ProtectedRoute roles={["super_admin", "mis", "hr", "ea"]} adminOnly><AppLayout><ChecklistAdmin /></AppLayout></ProtectedRoute>} />
            <Route path="/checklist" element={<DelegationShell><ChecklistActivity /></DelegationShell>} />
            {/* Phase 7 — Driver Attendance (logistics_manager) */}
            <Route path="/logistics/driver-attendance" element={<ProtectedRoute roles={["super_admin", "hr", "logistics_manager", "logistics_executive"]} adminOnly><AppLayout><DriverAttendance /></AppLayout></ProtectedRoute>} />
            <Route path="/logistics/hub" element={<ProtectedRoute roles={["super_admin", "hr", "logistics_manager", "logistics_executive"]} adminOnly><AppLayout><LogisticsHub /></AppLayout></ProtectedRoute>} />
            {/* Phase 9.1 — Accounts & EA consoles (no adminOnly: ea can be employee-flavoured) */}
            <Route path="/accounts/dashboard" element={<ProtectedRoute roles={["super_admin", "hr", "accounts"]}><AppLayout><AccountsDashboard /></AppLayout></ProtectedRoute>} />
            <Route path="/ea/dashboard" element={<ProtectedRoute roles={["super_admin", "hr", "ea"]}><AppLayout><EADashboard /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/biometric-matching" element={<HrShell><BiometricMatching /></HrShell>} />
            <Route path="/admin/biometric-mappings" element={<HrShell><BiometricMappings /></HrShell>} />
            <Route path="/admin/unit1-biometric-fix" element={<ProtectedRoute roles={["super_admin"]} adminOnly><AppLayout><Unit1BiometricFix /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/payroll-rules" element={<HrShell><PayrollRules /></HrShell>} />
            <Route path="/admin/communications" element={<HrShell><CommunicationSettings /></HrShell>} />
            <Route path="/logistics/fastag-map" element={<HrShell><FastagMap /></HrShell>} />
            <Route path="/logistics/fleet-compliance" element={<ProtectedRoute roles={["super_admin", "senior_management", "hr", "logistics_manager", "logistics_executive", "accounts", "ea"]} adminOnly><AppLayout><FleetCompliance /></AppLayout></ProtectedRoute>} />
            <Route path="/logistics/vehicle-ops" element={<ProtectedRoute roles={["super_admin", "senior_management", "hr", "logistics_manager", "logistics_executive", "accounts", "ea"]} adminOnly><AppLayout><VehicleOps /></AppLayout></ProtectedRoute>} />
            <Route path="/logistics/fleet-status" element={<ProtectedRoute roles={["super_admin", "senior_management", "hr", "logistics_manager", "logistics_executive", "accounts", "ea"]} adminOnly><AppLayout><FleetStatusBoard /></AppLayout></ProtectedRoute>} />
            <Route path="/logistics/lm-mobile" element={<ProtectedRoute roles={["super_admin", "logistics_manager", "logistics_executive", "ea"]} adminOnly><AppLayout><LMTripMobile /></AppLayout></ProtectedRoute>} />

            {/* Phase 15.10 — LM mobile-app shell (sidebar-free, bottom-nav). Default landing for logistics_manager. */}
            <Route path="/lm" element={<LMShell><LMTripMobile /></LMShell>} />
            <Route path="/lm/status" element={<LMShell><FleetStatusBoard /></LMShell>} />
            <Route path="/lm/fuel" element={<LMShell><LMFuelMobile /></LMShell>} />
            <Route path="/lm/more" element={<LMShell><LMMore /></LMShell>} />

            {/* Phase 15.11 — Employee mobile shell (sidebar-free, bottom-nav). Default landing for employees. */}
            <Route path="/me" element={<EmployeeShell><MeHome /></EmployeeShell>} />
            <Route path="/me/attendance" element={<EmployeeShell><MeAttendance /></EmployeeShell>} />
            <Route path="/me/tasks" element={<EmployeeShell><MeTasks /></EmployeeShell>} />
            <Route path="/me/leaves" element={<EmployeeShell><MeLeaves /></EmployeeShell>} />
            <Route path="/me/more" element={<EmployeeShell><MeMore /></EmployeeShell>} />
            <Route path="/hr/asset-handover" element={<ProtectedRoute roles={["super_admin", "hr", "it_admin", "accounts", "senior_management", "ea", "reporting_manager"]} adminOnly><AppLayout><EmployeeAssetHandover /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/compliance" element={<ProtectedRoute roles={["super_admin", "senior_management", "hr", "accounts", "ea"]} adminOnly><AppLayout><Compliance /></AppLayout></ProtectedRoute>} />
            <Route path="/payroll/comparison" element={<HrShell><PayrollComparison /></HrShell>} />
            <Route path="/leaves/approvals" element={<Shell><LeaveApprovals /></Shell>} />
            <Route path="/admin/org-chart" element={<HrShell><OrgChart /></HrShell>} />
            <Route path="/admin/holidays" element={<HrShell><AdminHolidays /></HrShell>} />
            <Route path="/admin/optional-leaves" element={<HrShell><AdminOptionalLeaves /></HrShell>} />
            <Route path="/attendance/monthly" element={<Shell><AttendanceMonthly /></Shell>} />
            <Route path="/payroll" element={<HrShell><PayrollList /></HrShell>} />
            <Route path="/payroll/runs/:id" element={<HrShell><PayrollRunDetail /></HrShell>} />
            <Route path="/reports" element={<HrShell><Reports /></HrShell>} />

            <Route path="/settings" element={<AdminShell><Settings /></AdminShell>} />
            <Route path="/settings/users" element={<AdminShell><Users /></AdminShell>} />
            <Route path="/settings/audit" element={<AdminShell><AuditLog /></AdminShell>} />
            <Route path="/settings/disaster-recovery" element={<AdminShell><DisasterRecovery /></AdminShell>} />

            {/* Employee Self-Service Portal */}
            <Route path="/my-portal" element={<Navigate to="/my-portal/dashboard" replace />} />
            <Route path="/my-portal/dashboard" element={<PortalShell><PortalDashboard /></PortalShell>} />
            <Route path="/my-portal/profile" element={<PortalShell><PortalProfile /></PortalShell>} />
            <Route path="/my-portal/attendance" element={<PortalShell><PortalAttendance /></PortalShell>} />
            <Route path="/my-portal/salary" element={<PortalShell><PortalSalary /></PortalShell>} />
            <Route path="/my-portal/leaves" element={<PortalShell><PortalLeaves /></PortalShell>} />
            <Route path="/my-portal/todos" element={<PortalShell><PortalTodos /></PortalShell>} />
            <Route path="/my-portal/holidays" element={<PortalShell><PortalHolidays /></PortalShell>} />
            <Route path="/my-portal/approvals" element={<PortalShell><LeaveApprovals /></PortalShell>} />
            <Route path="/my-portal/documents" element={<PortalShell><PortalDocuments /></PortalShell>} />
            <Route path="/my-portal/announcements" element={<PortalShell><PortalAnnouncements /></PortalShell>} />

            {/* Phase 5M — Broadcast Messaging */}
            <Route path="/admin/broadcasts" element={<ProtectedRoute roles={["super_admin", "hr", "senior_management", "hod"]}><AppLayout><Broadcasts /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/broadcasts/:id" element={<ProtectedRoute roles={["super_admin", "hr", "senior_management", "hod"]}><AppLayout><Broadcasts /></AppLayout></ProtectedRoute>} />

            {/* Delegation Workflow — accessible to both admin and portal principals */}
            <Route path="/delegation" element={<Navigate to="/delegation/tasks" replace />} />
            <Route path="/delegation/tasks" element={<DelegationShell><DelegationList /></DelegationShell>} />
            <Route path="/delegation/create" element={<DelegationShell><DelegationCreate /></DelegationShell>} />
            <Route path="/delegation/tasks/:id" element={<DelegationShell><DelegationDetail /></DelegationShell>} />

            {/* Employee Service Requests — Phase 1 */}
            <Route path="/my-portal/requests" element={<PortalShell><RequestList mode="mine" /></PortalShell>} />
            <Route path="/my-portal/requests/new" element={<PortalShell><RequestNew /></PortalShell>} />
            <Route path="/my-portal/requests/:id" element={<PortalShell><RequestDetail /></PortalShell>} />
            <Route path="/admin/requests" element={<DelegationShell><RequestList mode="admin" /></DelegationShell>} />
            <Route path="/admin/requests/analytics" element={<DelegationShell><RequestAnalytics /></DelegationShell>} />
            <Route path="/admin/requests/:id" element={<DelegationShell><RequestDetail /></DelegationShell>} />
            <Route path="/admin/approvals/requests" element={<DelegationShell><ApprovalQueue /></DelegationShell>} />

            {/* Employee Master Record (HR + Super Admin only) */}
            <Route path="/employees/:id/master-record" element={<ProtectedRoute roles={["super_admin", "hr"]}><AppLayout><EmployeeMasterRecord /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/appraisal-dashboard" element={<ProtectedRoute roles={["super_admin", "hr"]}><AppLayout><AppraisalDashboard /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/salary-calculator" element={<ProtectedRoute roles={["super_admin", "hr"]}><AppLayout><SalaryCalculator /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/festivals" element={<ProtectedRoute roles={["super_admin", "hr", "senior_management"]}><AppLayout><FestivalsList /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/festivals/:id" element={<ProtectedRoute roles={["super_admin", "hr", "senior_management"]}><AppLayout><FestivalDetail /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/festival-tiers" element={<ProtectedRoute roles={["super_admin", "hr"]}><AppLayout><FestivalTiers /></AppLayout></ProtectedRoute>} />
            <Route path="/my-portal/festivals" element={<PortalShell><MyFestivalHistory /></PortalShell>} />
            {/* Advance Management — Phase 4A */}
            <Route path="/my-portal/advances" element={<PortalShell><MyAdvancesList /></PortalShell>} />
            <Route path="/my-portal/advances/new" element={<PortalShell><MyAdvancesNew /></PortalShell>} />
            <Route path="/my-portal/assets" element={<PortalShell><MyAssetHandovers /></PortalShell>} />
            <Route path="/admin/advances" element={<ProtectedRoute roles={["super_admin", "hr", "senior_management", "accounts", "unit_manager"]}><AppLayout><AdvanceApprovalQueue /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/advances/reports" element={<ProtectedRoute roles={["super_admin", "hr", "accounts", "unit_manager"]}><AppLayout><AdvanceReports /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/financial-years" element={<ProtectedRoute roles={["super_admin", "hr", "senior_management", "accounts"]}><AppLayout><FinancialYears /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/performance" element={<ProtectedRoute roles={["super_admin", "hr", "senior_management", "hod"]}><AppLayout><PerformanceScoring /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/sm-checklist" element={<ProtectedRoute roles={["super_admin", "mis", "ea"]}><AppLayout><SMChecklist /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/sm-checklist/monthly" element={<ProtectedRoute roles={["super_admin", "mis", "ea", "senior_management"]}><AppLayout><SMChecklistMonthly /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/ea-mappings" element={<ProtectedRoute roles={["super_admin", "mis"]}><AppLayout><EAMappings /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/recruitment" element={<ProtectedRoute roles={["super_admin", "senior_management", "hr", "hod", "unit_manager", "team_leader"]}><AppLayout><Recruitment /></AppLayout></ProtectedRoute>} />
            <Route path="/my-portal/sm-checklist" element={<PortalShell><MySMChecklist /></PortalShell>} />
            <Route path="/my-portal/performance" element={<PortalShell><MyPerformance /></PortalShell>} />

            {/* Phase 10 — Driver Fuel Refill (mobile-first PWA) */}
            <Route path="/driver" element={<DriverShell><DriverHome /></DriverShell>} />
            <Route path="/driver/fuel/new" element={<DriverShell><FuelRefill /></DriverShell>} />
            <Route path="/driver/refills" element={<DriverShell><MyRefills /></DriverShell>} />
            <Route path="/driver/refills/:id" element={<DriverShell><RefillDetail /></DriverShell>} />
            <Route path="/driver/trips" element={<DriverShell><MyTrips /></DriverShell>} />
            <Route path="/driver/trips/new" element={<DriverShell><TripLog /></DriverShell>} />
            <Route path="/driver/trips/:id" element={<DriverShell><TripDetail /></DriverShell>} />
            <Route path="/driver/trips/:tripId/market-return" element={<DriverShell><MarketReturnLog /></DriverShell>} />
            <Route path="/driver/mileage" element={<DriverShell><MyMileage /></DriverShell>} />
            <Route path="/driver/inspection/new" element={<DriverShell><DriverInspection /></DriverShell>} />
            <Route path="/driver/handovers" element={<DriverShell><DriverHandovers /></DriverShell>} />
            <Route path="/driver/maintenance/new" element={<DriverShell><DriverMaintenance /></DriverShell>} />
            <Route path="/logistics/fuel" element={<ProtectedRoute roles={["super_admin", "hr", "logistics_manager", "logistics_executive", "accounts"]} adminOnly><AppLayout><FuelAdmin /></AppLayout></ProtectedRoute>} />
            <Route path="/attendance-v2" element={<ProtectedRoute roles={["super_admin", "hr"]} adminOnly><AppLayout><AttendanceV2 /></AppLayout></ProtectedRoute>} />
            {/* Phase 5A — Punch Terminal */}
            <Route path="/punch/:unitId" element={<ProtectedRoute><PunchTerminal /></ProtectedRoute>} />
            <Route path="/admin/punch-attendance" element={<ProtectedRoute roles={["super_admin", "hr", "unit_manager"]}><AppLayout><PunchAttendance /></AppLayout></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
